import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
const Aside2 = () => {
    const location = useLocation();
    const [activePath, setActivePath] = useState(location.pathname);

    const handleActiveLink = (path) => {
        setActivePath(path);
    };

    return (
       <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
  <div className="app-brand demo ps-0 ms-0">
    <a href="index.html" className="app-brand-link">
      <span className="app-brand-text demo menu-text fw-bold ms-2">notaryo</span><br/>
      <span className="app-brand-text demo menu-text fw-bold ms-2">publiko</span>
    </a>
    <a href="javascript:void(0);" className="layout-menu-toggle menu-link text-large ms-auto text-warning">
      <i className="bx bx-chevron-left bx-sm d-flex align-items-center justify-content-center" />
    </a>
  </div>
  <div className="menu-inner-shadow" />
  <ul className="menu-inner py-1">
 
    <li className={`menu-item ${activePath === '/' ? 'active' : ''}`}>
        <Link to="/" className="menu-link" onClick={() => handleActiveLink('/')}>
            <i className="menu-icon tf-icons bx bx-home-circle fw-bolder" />
            <div>Transactions</div>
        </Link>
    </li>

    
    <li className={`menu-item ${activePath === '/notarialbook' ? 'active' : ''}`}>
        <Link to="/notarialbook" className="menu-link" onClick={() => handleActiveLink('/notarialbook')}>
            <i className="menu-icon tf-icons bx bx-book  fw-bolder" />
            <div>Notarial Book</div>
        </Link>
    </li>
     
  </ul>
</aside>

    );
};

export default Aside2;
